import type { SelectField } from "@payloadcms/plugin-form-builder/types"
import type { Control, FieldErrorsImpl } from "react-hook-form"

import { Label } from "@/components/ui/label"
import {
	Select as SelectComponent,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select"
import React from "react"
import { Controller } from "react-hook-form"

import { Error as FormError } from "../Error"
import { Width } from "../Width"
import { provinces } from "@/data/provinces"

export const Provincia: React.FC<
	SelectField & {
		control: Control
		errors: Partial<FieldErrorsImpl>
	}
> = ({ name, control, errors, label, required, width, defaultValue }) => {
	const options = provinces.map((province) => ({
		label: province.label,
		value: province.value,
	}))

	return (
		<Width width={width}>
			<Label htmlFor={name}>
				{label}
				{required && (
					<span className="required">
						* <span className="sr-only">(required)</span>
					</span>
				)}
			</Label>
			<Controller
				control={control}
				defaultValue={defaultValue}
				name={name}
				render={({ field: { onChange, value } }) => {
					const controlledValue = options.find((t) => t.value === value)

					return (
						<SelectComponent
							onValueChange={(val) => onChange(val)}
							value={controlledValue?.value}
						>
							<SelectTrigger className="w-full" id={name}>
								<SelectValue placeholder={label} />
							</SelectTrigger>
							<SelectContent>
								{options.map(({ label, value }) => {
									return (
										<SelectItem key={value} value={value}>
											{label}
										</SelectItem>
									)
								})}
							</SelectContent>
						</SelectComponent>
					)
				}}
				rules={{ required }}
			/>
			{errors[name] && <FormError name={name} />}
		</Width>
	)
}
